import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { editRequest } from '@app/_models/editRequest';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { VerifyDocumentEventServiceService } from '@app/_services/verify-document-event-service.service';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Moment } from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMMM/YYYY',
  },
  display: {
    dateInput: 'MMMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-employer-verify-document-edit',
  templateUrl: './employer-verify-document-edit.component.html',
  styleUrls: ['./employer-verify-document-edit.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EmployerVerifyDocumentEditComponent implements OnInit {

  constructor(private verifyDocumentEventServiceService: VerifyDocumentEventServiceService,
    private verifyDocService: VerifyDocumentService,private formBuilder: FormBuilder,
    private modalService: NgbModal,private documentVerificationListService: DocumentVerificationListService,
    private SpinnerService: NgxSpinnerService,
    private cdr: ChangeDetectorRef) { }

    date = new FormControl(moment([2020, 1]));
    preDate = new FormControl(moment([2019, 1]))

  id
  editForm: FormGroup;
  firstName;
  lastName;
  seatNumber;
  streamDropDown;
  streamId;
  prevStreamName;
  branchDropDown;
  branchId;
  semDropDown;
  semId;
  documentDropDown;
  docId;
  RequestTypeDropDown;
  requestId;
  collegeDropDown;
  collegeId;
  collegeName;
  YearOfPassDropDown;
  yearofpassid;
  monthofpassing;
  altEmailLengthCheck = false;
  altEmailValidation = false;
  // altEmail;
  submitted = false;
  filePath;
  fileSizeErr = false;
  editRequest = new editRequest();
  uploaddocpath;
  docChange = false;
  strMessage;
  editReason;
  fillSemBranch = false;
  isVrPdf: boolean = false;
  isVrImage: boolean = false;
  newFileCheck = false;
  EmbassyDropDown = [];
  embassyidDisabled = false;
  EmbassyshowErr = false;
  fillembassyname = false;
  @ViewChild('showModalBoxImage', { read: TemplateRef }) showModalBoxImage: TemplateRef<any>;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  EMAIL_REGEXP = /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9A-Z](?:[a-z0-9A-Z]*[a-z0-9A-Z])?\.)+[a-z0-9A-Z](?:[a-z0-9A-Z]*[a-z0-9A-Z])?/;

  // date = new FormControl(moment());

  get f() { return this.editForm.controls; }

  ngOnInit(): void {

    this.editForm = this.formBuilder.group({
      id: [this.id], // this.id
      firstname: ['',Validators.required],
      lastname: ['',Validators.required],
      enrollno: ['',Validators.required],
      streamid: ['', Validators.required],
      branchid: ['', Validators.required],
      semid: ['', Validators.required],
      docname: ['', Validators.required],
      requesttype: ['', Validators.required],
      collegenameid: ['', Validators.required],
      // altemail: ['',Validators.required],
      uploaddocpath: ['', Validators.required],
      monthofpassing: ['',Validators.required], // this.monthOfPassing
      yearofpassid: ['', Validators.required], // this.yearofpassing
      filepath: [''],
      yearAndMonthSelect: [''],
      
    })

    this.verifyDocumentEventServiceService.on<any>().subscribe(
      data => {
        this.id = data
        // console.log("main id$$$$$$", data)
      }
    )

    this.verifyDocService.getEditVerifyDocData(this.id).pipe(first()).subscribe(data => {
      console.log("data ====", data)
      this.editRequest = data.respData;
      // this.firstName = data.respData.first_name;
      // this.lastName = data.respData.last_name;
      // this.seatNumber = data.respData.enroll_no;
      
      // 
      // 
      // 
      // this.collegeName = data.respData.college_name;
      
      // 
      // this.editForm.value.uploaddocpath = this.uploaddocpath;
      
      // this.editForm.value.filepath = data.respData.upload_doc_path;
      console.log(data.respData.monthOfPassing,"  -  ", data.respData.year_of_pass_id, "   -  ", data.respData.upload_doc_path )
      // this.altEmail = data.respData.alt_email;
      this.editForm = this.formBuilder.group({
        id: this.id, // this.id
        firstname: data.respData.first_name,
        lastname: data.respData.last_name,
        enrollno: data.respData.enroll_no,
        streamid: data.respData.stream_id,
        branchid: data.respData.branch_id,
        semid: data.respData.semid,
        docname: data.respData.doc_id,
        requesttype: data.respData.request_type_id,
        collegenameid: data.respData.college_name_id,
        altemail: data.respData.alt_email,
        uploaddocpath: data.respData.upload_doc_path,
        monthofpassing: data.respData.monthOfPassing, // this.monthOfPassing
        yearofpassid: data.respData.year_of_pass_id, // this.yearofpassing
        filepath: data.respData.upload_doc_path,
        yearAndMonthSelect : new FormControl(moment(data.respData.year+"-"+data.respData.monthOfPassing, "YYYY-MMMM")),
        embassyid:data.respData.embassyid,
        embassyname: data.respData.embassyname,
        embassyaddress: data.respData.embassyaddress,
      })
  
      this.streamId = data.respData.stream_id;
      this.editReason = data.respData.editReason;
      this.uploaddocpath = data.respData.upload_doc_path;
      this.semId = data.respData.semid;
      this.branchId = data.respData.branch_id;
      this.docId = data.respData.doc_id;
      this.requestId = data.respData.request_type_id;
      this.collegeId = data.respData.college_name_id;


      if(data.respData.embassyid == 2){

        this.embassyidDisabled = true;
      }

      // console.log(this.altEmail);
      // this.streamid = data.respData.stream_id
      // console.log("stream2 ====",this.streamid)
      // this.enrollno = data.respData.enroll_no

      this.verifyDocService.getBranch(this.streamId)
    .subscribe(
      data => {
        // console.log("branch data ++++++", data)
       this.branchDropDown = data.respData;
      },
      error => {
        console.log(error)
      }
    )

    this.verifyDocService.getSemester(this.streamId)
    .subscribe(
      data => {
        // console.log("semester data --->",data)
        this.semDropDown = data.respData;
      },
      error => {
        console.log(error)
      }
    )

    })

    this.verifyDocService.getStreams()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("streams response---", data.respData)
          this.streamDropDown = data.respData;
          // console.log("streamdropdown = ", this.streamDropDown)
        },
        error => {
          console.log(error)
        }
      )

      this.verifyDocService.getEmbassy()
      .pipe(first())
      .subscribe(
        data => {
           console.log("getEmbassy response---", data.respData)
          this.EmbassyDropDown = data.respData;
    //     console.log("getEmbassy response---", this.EmbassyDropDown)
     // alert("Check Embassy ----"+data.id);
     //  alert('payment_id: ' + payment_id);
  
          // this.editdocform.value.semid = "";
  
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getDocuments()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("Document response---", data.respData)
          this.documentDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

      this.verifyDocService.getRequestType()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("request drop down ----->", data)
          this.RequestTypeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

      this.verifyDocService.getColleges()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data)
          this.collegeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

      this.verifyDocService.getYearOfPassing()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("YearOfPassing response---", data.respData)
          this.YearOfPassDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }

  refresh(): void {
    location.reload();
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  document_path
  src
  fileURL
  noImage1 = false;
  isImageL = false;

  viewDocument(){
    console.log(this.id);
    this.documentVerificationListService.getDocument(this.id)
    .pipe(first())
    .subscribe(
      add => {
        console.log("addadd---", add, add.type)

        let reader = new FileReader();
        if (add.type == "application/pdf") {
          this.isVrPdf = true;
          this.isVrImage = false;
          reader.addEventListener("load", () => {
            this.document_path = reader.result;
            var base64Array = this.document_path.substring(28);
            console.log("=====base64Array===========", base64Array);
            this.src = this._base64ToArrayBuffer(base64Array);
            let file = new Blob([add], { type: 'application/pdf' });
            this.fileURL = URL.createObjectURL(file);
            // this.magnify('uploadImg1', 3);
          }, false);
        }
        else {
          this.isVrImage = true;
                  this.isVrPdf = false;
                  reader.addEventListener("load", () => {
                    this.document_path = reader.result;
                    this.noImage1 = false;
                    console.log(reader.result);
                    // this.magnify('uploadImg1', 3);
                  }, false);

        }
        console.log(this.isVrImage, this.isVrPdf,)
                if (add) {
                  reader.readAsDataURL(add);

                }
                this.isImageL = true;
                if (this.isVrPdf == true) {
                  var al = window.open('', 'OPEN');
                  window.setTimeout(function () { al.close() }, 100);
                }
                if (this.isImageL == true ) {
                  this.SpinnerService.hide();
                  // this.constVal = 0
                  // this.constValOriginal = 0
                  // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });

                  this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', size: 'lg', centered: true });
                }

      }, error => {
        this.SpinnerService.hide();
        // this.constVal = 0
        // this.constValOriginal = 0
        // this.modalService.open(this.showModalBoxImage, { size: 'xl', centered: true });
        this.modalService.open(this.showModalBoxImage, { windowClass: 'my-class', centered: true });
        this.document_path = "/University/assets/images/No-results-found.jpg"; // test server
        this.noImage1 = true;
        console.log(error)
      }
    )
  }

  openPdf() {
    window.open(this.fileURL);
  }

  inputChanged(event: any){
    console.log('inputChanged function--->',event.target.value);
    var inputString = event.target.value;

    // var inputString = document.getElementById('emailinput').value;
    var splitInput = inputString.split(',');

    // if(splitInput.length > 5){
    //   this.altEmailLengthCheck = true;
    // }else{
    //   this.altEmailLengthCheck = false;
    // }

    var pattern = this.EMAIL_REGEXP;

    var match = true;
    var count = 0;
    for(var i=0;i<splitInput.length;i++) {
      if(!String(splitInput[i]).match(pattern)){
        match = false;
        count = count +1;
        console.log('match = false')
        this.altEmailValidation = true;
      }
    }
    if(count == 0){
      this.altEmailValidation = false;
    }
    console.log('------BOOLEAN------->', this.altEmailValidation)
  }

  onSubmit(){
    // console.log("----------------------",this.editForm.value)
    if(this.docChange == false){
      this.editForm.value.uploaddocpath = this.uploaddocpath;
      console.log("upload doc path", this.uploaddocpath)
    }else{
      this.editForm.value.uploaddocpath = this.filePath;
    }
    // this.editForm.value.monthofpassing = this.editRequest.monthOfPassing;
    // this.editForm.value.yearofpassid = this.editRequest.year_of_pass_id;
    console.log("----->", this.editForm)
    this.submitted = true;
    
    if(this.editForm.invalid){
      return;
    }
    if(this.editForm.value.semid == ""){
      this.fillSemBranch = true;
    }
    else if(this.editForm.value.branchid == ""){
      this.fillSemBranch = true;
    }else if(this.editForm.value.embassyid == 1 && this.editForm.value.embassyname == ""){
      this.fillembassyname = true;
    }else if(this.editForm.value.embassyid == 3 && this.editForm.value.embassyname == ""){
      this.fillembassyname = true;
    }else if(this.editForm.value.embassyid == 1 && this.editForm.value.embassyaddress == ""){
      this.fillembassyname = true;
    }else if(this.editForm.value.embassyid == 3 && this.editForm.value.embassyaddress == ""){
      this.fillembassyname = true;
    }else{
    // edit save
    this.fillSemBranch = false;
    this.fillembassyname = false;
    
      this.verifyDocService.editVerificationRequest(this.editForm.value)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data)
          this.strMessage = "Verification Request updated.";
          this.modalService.open(this.showModalBoxTemplate);
        },
        error => {
          console.log(error)
        }
      )
    }

  }

  catchEvent(files: FileList) {
    console.log(files)
    this.newFileCheck = true;
    this.docChange = true;
    // console.log(i)
    if (files[0].size <= 5242880) {
      this.fileSizeErr = false;

      var formData = new FormData();
      formData.append("file", files.item(0));
      this.verifyDocService.uploadVerificationDocumentFile(formData)
        .pipe(first())
        .subscribe(
          data => {
            console.log("file---upload---response---", data)
            this.filePath = data.respData;
            this.editForm.value.uploaddocpath = this.filePath;
            // console.log(this.form.controls.StudentDocVerificationRequest.value[0]['uploaddocpath'])
          },
          error => {
            console.log(error)
          }
        )
    } else {
      
      this.fileSizeErr = true;
    }
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
    console.log("year val==", normalizedYear)

  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    console.log("month val==", normalizedMonth)
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    var r=this.YearOfPassDropDown.find(x => x.yearOfPassing === this.date.value.year().toString());
    // var v = moment(this.form.value.StudentDocVerificationRequest[0].yearAndMonth.month() + 1, 'MM').format('MMMM');
    //const form = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(i);
    console.log("ctr val==", ctrlValue)

    this.editForm.patchValue({
      // yearAndMonth: this.date.value,
      // yearAndMonthSelect: this.date.value,
      monthofpassing:moment(this.date.value.month()+1, 'MM').format('MMMM'),
      yearofpassid:r.id,
    });

  }

  dateFilter = (d: any): boolean => { 
    
   // console.log("d===---", d)

    // const day = (d || new Date()).getDay();
    // // Prevent Saturday and Sunday from being selected.
    // return day !== 0 && day !== 6;

    const day = d.year();
    var val = [];
    this.YearOfPassDropDown.forEach((keys: any, vals: any) => {
      var x = keys.yearOfPassing;
      var y: number = +x;
      day !== y + "";
      val.push(y);
    })
    var alphaNumeric = val.join("  && day !== ");;
    var aq = (day !== + alphaNumeric);
    var stringValueYouWant = val.join();

    return stringValueYouWant.indexOf(d.year()) !== -1;
  }

  getBranAndStream(i: any) {
    let y = i.split(':')[1];
    let id = Number(y);
    console.log(id);

    this.verifyDocService.getBranch(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("branch new response---", data.respData)
          this.branchDropDown = data.respData;
          this.branchId = "";
          this.editForm.value.branchid = "";
        },
        error => {
          console.log(error)
        }
      )


    this.verifyDocService.getSemester(id)
      .pipe(first())
      .subscribe(
        data => {
          console.log("Sem new response---", data.respData)
          this.semDropDown = data.respData;
          this.semId = "";
          this.editForm.value.semid = "";
        },
        error => {
          console.log(error)
        }
      )
  }

  //get embassy list
getembassylist(i: any){

  let y = i.split(':')[1];
  
      let id = Number(y);
       console.log("id-----------------" + id);    
       if (id == 1 || id ==3)  {

        this.embassyidDisabled = false;
        this.EmbassyshowErr = true;
            this.cdr.detectChanges();
            console.log("Value of embassyidDisabled:", this.embassyidDisabled);
           //   this.form.controls.embassyname.disable();
                 console.log("disable11 = ", id);

        } else{


                console.log("Enable fasle:", this.embassyidDisabled);

                this.embassyidDisabled = true;
                this.EmbassyshowErr = false;

        }
}

}
